class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    document.getElementById('header-menu-background').removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('.menu-details');

    this.addEventListener('click', event => {
      if (!event.target.href) event.preventDefault()

      if(this.mainDetailsToggle.classList.contains('menu-details--click')) {
        if (event.target !== this.querySelector('summary')) return

        if (!this.mainDetailsToggle.hasAttribute('open') || !this.mainDetailsToggle.classList.contains('is-visible')) {
          this.open(event)
        }
        else {
          this.close()
        }
      }
    })

    this.addEventListener('mouseover', event => this.onHover(event))
    this.addEventListener('focus', event => this.onHover(event), true)
  }

  onHover(event) {
    event.target.href === undefined && event.preventDefault()
    if (event.target === this.mainDetailsToggle) this.close()

    if (event.target !== this.querySelector('summary') || this.mainDetailsToggle.classList.contains('menu-details--click')) return

    if (!this.mainDetailsToggle.hasAttribute('open') || !this.mainDetailsToggle.classList.contains('is-visible')) this.open(event)
  }

  open(event) {
    const allMegaMenus = document.querySelectorAll('.menu-details.is-visible')
    let wasOpened = false
    if (event.target.parentNode.classList.contains('menu-details')) {
      allMegaMenus.forEach(menu => {
        menu.classList.contains('is-visible') && (wasOpened = true)
        this.close(menu)
      })
    }

    this.mainDetailsToggle.setAttribute('open', '')
    if (!wasOpened) {
      this.mainDetailsToggle.classList.add('is-visible')
    } else {
      this.mainDetailsToggle.classList.add('is-visible', 'animate-between-menus')
      setTimeout(() => {
        this.mainDetailsToggle.classList.remove('animate-between-menus')
      }, 10);
    }
    this.mainDetailsToggle.querySelector('.header__submenu--grid')?.classList.add('is-visible')
  }

  close(elem = this.mainDetailsToggle) {
    elem.classList.remove('is-visible')
    elem.querySelector('.header__submenu--grid').classList.remove('is-visible')
    setTimeout(() => {
      elem.removeAttribute('open')
    }, 150)
  }
}
customElements.define('header-menu', HeaderMenu);

class HeaderSubMenu extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('.submenu-details');
    this.navigationCard = this.closest('.header__submenu').querySelector('.header__navigation-card')
    this.menuCaption = document.querySelector('.header__submenu__caption')
    this.menuCaption.innerText = document.querySelector('.submenu-details.is-visible summary').dataset.title;
    this.addEventListener('mouseover', event => this.onHover(event))
    this.addEventListener('focus', event => this.onHover(event), true)
    this.addEventListener('click', event => {
      if (!event.target.href) event.preventDefault()
    })
  }

  unicodeToChar(text) {
    if (text) {
      return text.replace(/\\u[\dA-F]{4}/gi, 
        function (match) {
          return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
        }
      );
    }
    return '';
  }

  onHover(event) {
    event.target.href == undefined && event.preventDefault()
    const convertedEventValue = this.unicodeToChar(event.target.dataset.title);

    if (event.target != this.querySelector('summary')) return

    if (!this.mainDetailsToggle.hasAttribute('open') || !this.mainDetailsToggle.classList.contains('is-visible')) {
      const allSubMenus = document.querySelectorAll('.submenu-details.is-visible')
      if (event.target.parentNode.classList.contains('submenu-details')) {
        allSubMenus.forEach(menu => {
          this.close(menu, true)
        })
      }
      if (this.navigationCard) {
        this.navigationCard.classList.add('is-hidden')
      }
      this.menuCaption && (this.menuCaption.innerText = convertedEventValue)

      this.mainDetailsToggle.setAttribute('open', '')
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('is-visible')
      }, 10)
    }
  }

  close(elem = this.mainDetailsToggle, keepNavigationCardHidden) {
    if (this.navigationCard) {
      !keepNavigationCardHidden && this.navigationCard.classList.remove('is-hidden')
    }
    elem.classList.remove('is-visible')
    elem.removeAttribute('open')
  }
}
customElements.define('header-submenu', HeaderSubMenu);